import React from "react";
import { useRouter } from "rhoto-router";
import DataContext from "./chart/DataContext";
import useTitle from "../hooks/useTitle";
import Spinner from "./Spinner";
import { useAPIData, useParquet } from "../api";
import Point from "../point";
import { Summary } from "../activity";
import { useUser } from "./UserLoader";

export interface ProcessedActivity {
  data: Point[];
  summary: Summary;
}

export interface Analysis {
  distance: number;
  meanEffort: number;
  effortDensity: number[];
}

export const StravaDataContext = ({
  userId,
  activityId,
  children,
}: {
  userId?: string;
  activityId: string;
  children: React.ReactNode;
}) => {
  const user = useUser();
  userId ||= user.stravaId.toString();
  const summary = useAPIData<Summary>(`/activities/${userId}/${activityId}`);
  const data = useParquet(userId, activityId);
  const activity = summary && data ? { summary, data } : null;

  const title = activity?.summary.name || "Loading...";
  const race = activity?.summary.race || false;
  useTitle(`${race ? "🏅 " : ""}${title}`);

  if (activity) {
    return (
      <DataContext.Provider value={activity}>{children}</DataContext.Provider>
    );
  } else if (activity === null) {
    return <Spinner />;
  } else {
    return null;
  }
};

export const StravaLoader = ({ children }: { children: React.ReactNode }) => {
  const router = useRouter();
  const { activityId, userId } = router.params;

  if (activityId) {
    return (
      <StravaDataContext userId={userId} activityId={activityId}>
        {children}
      </StravaDataContext>
    );
  } else {
    return null;
  }
};

export default StravaLoader;
